import { IListener, injectDataCache, injectSubject } from '@aesop-fables/scrinium';
import type { DataCache } from '@aesop-fables/scrinium';
import { Observable, Subscription, distinctUntilChanged } from 'rxjs';
import { Predicates } from '../../../predicates/Types';
import { TrustFamilyCompartments, trustFamilyStorageKey } from '..';

export class TrustFamilyListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.OrganizationSelected)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(trustFamilyStorageKey)
    private readonly cache: DataCache<TrustFamilyCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('trustFamilyData');
        } else {
          this.cache.reset('trustFamilyData');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}
